import { Link } from 'react-router-dom'
import * as routes from '../../routes'

const UserLink = ({user_id, username, disabled, className}) => {
  if (disabled) {
    return username
  }
  return <Link className={className} to={routes.dynamic(routes.adminCreatorProfilePath, user_id)}>{username ? username : user_id}</Link>
}

export default UserLink
